import { type UseQueryResult, useQuery } from 'react-query';
import {
  DistributableFeatureService,
  Wealthlane_AppServices_Features_DistributablePermissionListingDto,
  Wealthlane_Dtos_DistributableFeatureManageDto,
} from '../../services/wealthlane-identity-services';

const useGetDistributableFeaturesForCompany = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_Dtos_DistributableFeatureManageDto> | undefined,
  unknown
> => {
  const featuresPermissionsDistributable = useQuery(['getDistributableFeatures', id], async () => {
    return await handleRequest(
      DistributableFeatureService.getApiIdentityApiDistributableFeatures(id)
    );
  });

  return featuresPermissionsDistributable as any;
};

export default useGetDistributableFeaturesForCompany;
